import React from "react";
import PropTypes from "prop-types";
import { asNumber, guessType } from "react-jsonschema-form/lib/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var nums = new Set(["number", "integer"]);

/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */
function processValue(schema, value) {
  // "enum" is a reserved word, so only "type" and "items" can be destructured
  var type = schema.type,
    items = schema.items;
  if (value === "") {
    return undefined;
  } else if (type === "array" && items && nums.has(items.type)) {
    return value.map(asNumber);
  } else if (type === "boolean") {
    return value === "true";
  } else if (type === "number") {
    return asNumber(value);
  }

  // If type is undefined, but an enum is present, try and infer the type from
  // the enum values
  if (schema.enum) {
    if (schema.enum.every(function (x) {
      return guessType(x) === "number";
    })) {
      return asNumber(value);
    } else if (schema.enum.every(function (x) {
      return guessType(x) === "boolean";
    })) {
      return value === "true";
    }
  }
  return value;
}
function getValue(event, multiple) {
  if (multiple) {
    return [].slice.call(event.target.options).filter(function (o) {
      return o.selected;
    }).map(function (o) {
      return o.value;
    });
  } else {
    return event.target.value;
  }
}
function SelectWidget(props) {
  var schema = props.schema,
    id = props.id,
    options = props.options,
    value = props.value,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    multiple = props.multiple,
    autofocus = props.autofocus,
    _onChange = props.onChange,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    placeholder = props.placeholder;
  var enumOptions = options.enumOptions,
    enumDisabled = options.enumDisabled;
  var emptyValue = multiple ? [] : "";
  return /*#__PURE__*/_jsxs("select", {
    id: id,
    multiple: multiple,
    className: "form-control",
    value: typeof value === "undefined" ? emptyValue : value,
    required: required,
    disabled: disabled || readonly,
    autoFocus: autofocus,
    onBlur: onBlur && function (event) {
      var newValue = getValue(event, multiple);
      onBlur(id, processValue(schema, newValue));
    },
    onFocus: onFocus && function (event) {
      var newValue = getValue(event, multiple);
      onFocus(id, processValue(schema, newValue));
    },
    onChange: function onChange(event) {
      var newValue = getValue(event, multiple);
      _onChange(processValue(schema, newValue));
    },
    children: [!multiple && (schema.default === undefined || schema.default === "") && !enumOptions.find(function (_ref) {
      var value = _ref.value;
      return value === "";
    }) && /*#__PURE__*/_jsx("option", {
      hidden: true,
      value: "",
      children: placeholder
    }), enumOptions.map(function (_ref2, i) {
      var value = _ref2.value,
        label = _ref2.label;
      var disabled = enumDisabled && enumDisabled.indexOf(value) != -1;
      return /*#__PURE__*/_jsx("option", {
        value: value,
        disabled: disabled,
        children: label
      }, i);
    })]
  });
}
SelectWidget.defaultProps = {
  autofocus: false
};
if (process.env.NODE_ENV !== "production") {
  SelectWidget.propTypes = {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
      enumOptions: PropTypes.array
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    multiple: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  };
}
export default SelectWidget;
//# sourceMappingURL=SelectWidget.js.map